import React, { useMemo } from 'react';
import {
  AccountCircleOutlined,
  DevicesOutlined,
  FamilyRestroomOutlined,
  HelpOutlineOutlined,
  LocalHospitalOutlined,
  PaymentsOutlined,
  PeopleOutlined,
  RocketLaunchOutlined,
  VideoCallOutlined,
} from '@mui/icons-material';
import { SvgIconProps } from '@mui/material/SvgIcon';
import { supportCategoryRoute } from '@uplift/constants';
import { HelpCenterTile, HelpfulLinksSection } from '@uplift/pages';
import { getSupportArticlesByCategory, SupportArticleCategory } from './articles';

const CATEGORY_ICONS: Partial<Record<SupportArticleCategory, React.ComponentType<SvgIconProps>>> = {
  'getting-started': RocketLaunchOutlined,
  'matching': PeopleOutlined,
  'sessions': VideoCallOutlined,
  'account': AccountCircleOutlined,
  'payments': PaymentsOutlined,
  'technical': DevicesOutlined,
  'services': LocalHospitalOutlined,
  'family-couples': FamilyRestroomOutlined,
  'general': HelpOutlineOutlined,
};

export const SupportArticleIndex: React.FC = () => {
  const tiles = useMemo((): HelpCenterTile[] => (
    getSupportArticlesByCategory()
      .filter(group => group.articles.length > 0)
      .map(group => ({
        title: group.label,
        description: group.description,
        icon: CATEGORY_ICONS[group.category] ?? HelpOutlineOutlined,
        href: supportCategoryRoute.createLink({ category: group.category }),
      }))
  ), []);

  return (
    <HelpfulLinksSection
      heading="Browse by topic"
      tiles={tiles}
    />
  );
};
